import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';
import nameSort from 'scaleflow/utils/nameSort';

export default class IdeasTableCellAreaComponent extends DropdownActivator {
  @service store;
  @tracked areaFormIsVisible = false;
  selectedIdea = null;

  get idea() {
    return this.args.idea;
  }

  @action
  handleAreasChange(idea, e) {
    const areas = e.map((id) => this.store.peekRecord('area', id));
    idea.areas = areas;
    idea.save();
  }

  @action
  toggleAreaForm(idea, val) {
    if (idea) this.selectedIdea = idea;
    else this.selectedIdea = null;
    if (val !== undefined) this.areaFormIsVisible = val;
    else this.areaFormIsVisible = !this.areaFormIsVisible;
  }

  @action
  async onAreaAdded(area) {
    const areas = [...this.selectedIdea.areas.content];
    areas.push(area);
    this.selectedIdea.areas = areas;
    await this.selectedIdea.save();
  }

  get areasList() {
    const areas = this.store.peekAll('area').map((item) => ({
      value: item.id,
      label: item.name,
    }));
    return areas;
  }

  get sortedAreas() {
    return this.idea.areas?.content?.toSorted((a, b) =>
      nameSort(a.name, b.name, 'asc'),
    );
  }

  get firstArea() {
    return this.sortedAreas?.[0];
  }

  willDestroy() {
    this.areaFormIsVisible = false;
    this.selectedIdea = null;
    super.willDestroy(...arguments);
  }
}
